export class RequestAppointmentUrl {
    public static get GET_BOOKING_INIT(): string { return '/api/booking/patient/init'; }
    public static get GET_ALL_CENTRE(): string { return '/api/booking/clinic' }
    public static get ADD_BOOKING_CACHE(): string { return '/api/booking/patient/addbooking' }
    public static get GET_BOOKING_CACHE(): string { return '/api/booking/patient/{centreId}/booking' }
    public static get IMPORT_FILE_EXCEL(): string { return '/api/booking/patient/importmember' }
    public static get DOWNLOAD_FILE_TEMPLATE(): string { return '/api/booking/getfiletemplate' }
    public static get ADD_BOOKING(): string { return '/api/booking/patient'; }
    public static get DELETE_BOOKING_CACHE(): string { return '/api/booking/patient/delete'; }
    public static get BOOKING_DETAIL(): string { return '/api/booking/patient/{id}/detail'; }
    public static get GET_ALL_BOOKINGS(): string { return '/api/booking/patient/bookings'; }
    public static get DELETE_BOOKING(): string { return '/api/booking/patient/{id}/delete'; }
    public static get CHANGE_TIME_BOOKING(): string { return '/api/booking/patient/changetimebooking/' }
    public static get ADD_GROUP_BOOKING(): string { return '/api/booking/patient/bookinggroup' }

}


// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/urls/request-appointment.url.ts